<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 設問セット詳細（編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>設問セット詳細（編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/quest-set-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          IDが表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 設問一覧
        </div>
        <div class="manual-explain">
          設問セットに登録されている設問の一覧が表示されます。
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 表示タイトル
      </div>
      <div class="manual-explain">
        アンケートのタイトルを設定します。<br>
        ユーザー画面（アンケート選択）に表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 管理名称
      </div>
      <div class="manual-explain">
        管理名称を設定します。<br>
        アンケート結果ダウンロード時のアンケート選択リストに表示されます。<br>
        ※ユーザー画面には表示されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> 表示順
      </div>
      <div class="manual-explain">
        ユーザー画面（アンケート選択）に表示するアンケートの表示順を設定します。<br>
        「アンケートを表示する」チェックONのアンケートが対象となります。<br>
        チェックOFFのアンケートは表示順が設定されていても、ユーザー画面には表示されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> アンケートを表示する
      </div>
      <div class="manual-explain">
        チェックONにすると、アンケートをユーザー画面に表示します。<br>
        （チェックONにするとユーザー画面から回答が登録されるため、設問リストの編集は不可となります。）<br>
        チェックOFFにした場合は、アンケートをユーザー画面に表示しません。<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> 設問リスト一覧
      </div>
      <div class="manual-explain">
        「設問リスト追加」ボタンから、アンケートにセットする設問を選択します。<br>
        選択した設問を一覧上に表示します。一覧上で設問の順番を入れ替えることが可能です。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/H.png"> プレゼント用画像ファイル
      </div>
      <div class="manual-explain">
        プレゼント用画像を設定します。<br>
        ファイル追加ボタンからファイルを選択します。<br>
        ※ファイルは、<a [href]="uploaderDLLink">アップロードファイル画面（プレゼント用）</a>で事前にアップロードしてある必要があります。<br>
        ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像がない場合は日本語用の画像がダウンロードされます。<br>
        画像は複数登録可能ですが、ユーザー側でダウンロードできる画像は１つとなります（例：日本語の画像登録が2つ以上の場合は、1つ目の登録画像がダウンロードされます）。<br>
        また、施設画像はドラッグ&ドロップで並び替えが可能です。<br>
        ※画像の推奨サイズ（縦横比）は以下になります。<br>
        &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> 追加／更新ボタン
      </div>
      <div class="manual-explain">
        クリックすることで編集内容が更新されます。
      </div>

    </mat-card-content>
  </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Guide Top</a> &raquo; Question Set Details (Edit) Explanation
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Question Set Details (Edit) Explanation</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_quest-set-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close button
        </div>
        <div class="manual-explain">
          Clicking this closes the dialog. <br>
          Edited content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          The ID is displayed.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Question List
        </div>
        <div class="manual-explain">
          A list of questions registered in the question set is displayed.
        </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Display Title
      </div>
      <div class="manual-explain">
        Set the title of the questionnaire. <br>
        This will be displayed on the user screen (questionnaire selection).
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> Management Name
      </div>
      <div class="manual-explain">
        Set the management name. <br>
        This will be displayed in the questionnaire selection list when downloading the results. <br>
        *Not displayed on the user screen.
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> Display Order
      </div>
      <div class="manual-explain">
        Set the display order of questionnaires to be shown on the user screen (questionnaire selection). <br>
        Only questionnaires with "Display questionnaire" checked ON are eligible. <br>
        Questionnaires with this checkbox OFF will not be displayed on the user screen, even if an order is set.
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> Display questionnaire
      </div>
      <div class="manual-explain">
        When checked ON, the questionnaire will be displayed on the user screen. <br>
        (When checked ON, responses can be registered from the user screen, so editing the question list will be disabled.) <br>
        When checked OFF, the questionnaire will not be displayed on the user screen. <br>
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> Question List Overview
      </div>
      <div class="manual-explain">
        Select questions to be set for the questionnaire from the "Add Question List" button. <br>
        Selected questions are displayed in a list. The order of questions can be rearranged in the list.
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/H.png"> Image file for gift
      </div>
      <div class="manual-explain">
        Set the image for the gift. <br>
        Select a file from the "Add File" button. <br>
        *Files must be uploaded in advance on the <a [href]="uploaderDLLink">Uploaded Files screen (for gifts)</a>. <br>
        *Image settings are possible per language. If there is no image for the corresponding language, the English image will be downloaded; if there is no English image, the Japanese image will be downloaded. <br>
        Multiple images can be registered, but only one image can be downloaded by the user (e.g., if two or more Japanese images are registered, the first registered image will be downloaded). <br>
        Also, facility images can be rearranged by dragging and dropping. <br>
        *Recommended image size (aspect ratio) is as follows: <br>
        &nbsp;&nbsp;Main image: 1 : 1 (e.g.) Height 1400px, Width 1400px
      </div>
  
      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> Add / Update button
      </div>
      <div class="manual-explain">
        Clicking this will update the edited content.
      </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>
</div>

